<template>
  <div>
    <div class="ai-input">
      <el-form-item :label="label" :prop="name">
        <el-input
            type="textarea"
            :autosize="{ minRows: 5}"
            :placeholder="placeholder"
            v-model="originalText"
            @input="onInputChange">
        </el-input>
      </el-form-item>
      <div class="ai-button" @click="onStart">
            <img src="../../assets/images/ai.png" alt="ai" />ai润色
      </div>
    </div>
    <el-form-item>
        <div v-if="showAi" class="ai-response">
          <el-alert 
            v-if="!loading" 
            :title="errMsg || (responseData.content ? 'AI结果已整理完成' : '等待输入优化建议')" 
            type="info" 
            closable
            @close="onCancel"
          />
          <el-alert 
            v-else 
            title="AI整理中，请稍等。" 
            type="info" 
            closable
            @close="onCancel"
          />
          <div v-html="responseData.content" class="content"></div>
          <div class="bottom">
            <el-button 
              v-if="!loading && responseData.content" 
              size="small" 
              icon="el-icon-refresh" 
              @click="onStart"
            >
              重试
            </el-button>
            <el-button 
              v-if="!loading && responseData.content" 
              size="small" 
              type="primary" 
              icon="el-icon-swap"
              @click="onReplace"
            >
              替换
            </el-button>
            <el-button 
              v-if="loading" 
              icon="el-icon-close" 
              @click="onStop"
            >
              停止
            </el-button>
          </div>
        </div>
    </el-form-item>
  </div>
</template>

<script>
import { useChatMixin } from "./useChatMixin";

export default {
  name: 'AiControl',
  mixins: [useChatMixin],
  props: {
    value:String,
    label: String,
    name: String,
    aiType: {
      type: Number,
      default: 8,
    },
    placeholder: {
      type: String,
      default: '请输入内容',
    },
  },
  data() {
    return {
      showAi: false,
      errMsg: '',
      originalText: '',
    };
  },
  methods: {
    getPlainText(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },

    onStart() {
      const originalText = this.getPlainText(this.originalText);
      if (!originalText || originalText === 'undefined') {
        this.$message.error('请输入内容后再进行润色。');
        return;
      }
      this.abort();
      this.showAi = true;
      this.sendMessage(originalText, this.aiType);
    },

    onReplace() {
      let responseContent = this.responseData.content || '';
      responseContent = responseContent.replace(/<br\s*\/?>/gi, '\n');
      this.originalText = responseContent;
      this.onInputChange(responseContent);
      this.showAi = false;
      this.abort();  // 使用mixin中的abort方法
    },
    onInputChange(val) {
      console.log('Input changed:', val);
      this.$emit('input', val);
    },
    onCancel() {
      this.abort();  // 使用mixin中的abort方法
      this.showAi = false;
    },

    onStop() {
      this.stop();  // 使用mixin中的stop方法
    },

    onError(msg) {
      this.errMsg = msg;
    },
  },
  watch: {
    value(newVal) {
      this.originalText = newVal;
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-input {
  position: relative;
  .ai-button {
    position: absolute;
    right: 12px;
    bottom: 12px;
    font-size: 14px;
    color: rgba(0,0,0,0.55);
    cursor: pointer;
    display: flex;
    align-items: center;
    img{
      width: 31px;
      margin-right: 10px;
    }
  }
}
.ai-response {
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #e0e0e0;
}
.content {
  margin-top: 16px;
}
.bottom {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
